<template>
  <div class="sampler">
    <div :id="id"></div>
  </div>
</template>

<script>
export default {
  name: 'sampler',
  props: {
    name: { type: String, required: true },
    program: { type: String, required: true },
    id: { type: String, required: true },
    iframeLink: { type: String, required: true },
    autoParameter: { type: String, required: true },
  },
  mounted() {
    /* istanbul ignore next */
    if (window.eventBus) {
      window.eventBus.$on('script.loaded', (data) => {
        if (data.name === this.name) {
          samplerIframe(this.iframeLink, this.program, this.id, this.autoParameter); // eslint-disable-line no-undef
        }
      });
    } else {
      console.warn(`Could not load ${this.name}.`);
    }
  },
};
</script>

<style>
.sampler {
  margin-bottom: 30px;
}
</style>
